import React from 'react'
import { Link } from 'react-router-dom'
import { Delta } from './HomeKpiTiles'
import { moneyCards } from './model'

// "Money in and out": Financial's own figures, each on its own card and
// never added together - see moneyCards() in ./model.
export default function MoneyCards({ money }) {
  const cards = moneyCards(money)
  return (
    <section aria-labelledby="hm-money-title" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div className="hm-card-head">
        <h2 id="hm-money-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Money in and out</h2>
        <Link className="hm-link" to="/receivables">Open Financial →</Link>
      </div>
      <div className="hm-money">
        {cards.map((c) => (
          <div key={c.id} className="card" data-testid={`money-${c.id}`} style={{ padding: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-muted)', marginBottom: 6 }}>{c.title}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: c.value ? 'var(--text-primary)' : 'var(--text-muted)', fontVariantNumeric: 'tabular-nums' }}>
              {c.value || '—'}
            </div>
            <Delta deltaPct={c.deltaPct} comparison={c.comparison} />
            {c.lines.map((line) => (
              <div key={line} style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 4 }}>{line}</div>
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}
